import React from 'react'

const AdobeKnowledgeRepo = () => {
    return (
        <div style={{ height: 'calc(100vh - 95px)' }}>
            <iframe title='adobeknowledgerepo' src="https://docs.google.com/spreadsheets/d/1ZB4a5UMxE1SqG12TPoQbW9oCRbzkXxyYFkAud-siI3I/edit?usp=sharing" width="100%" height="100%"></iframe>
        </div>
    )
}

export default AdobeKnowledgeRepo;